(function () {
  'use strict';

  var MAX_DISTANCE_MILES = 200;
  var US_BOUNDS = [[-125, 17.5], [-65, 50]];

  function query(root, id) {
    return root.querySelector('[data-ctm-id="' + id + '"]');
  }

  function isVisible(root) {
    return window.getComputedStyle(root).display !== 'none';
  }

  function toRadians(value) {
    return value * Math.PI / 180;
  }

  function distanceMiles(lat1, lon1, lat2, lon2) {
    var earthRadius = 3958.8;
    var latitudeDelta = toRadians(lat2 - lat1);
    var longitudeDelta = toRadians(lon2 - lon1);
    var a = Math.sin(latitudeDelta / 2) * Math.sin(latitudeDelta / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
      Math.sin(longitudeDelta / 2) * Math.sin(longitudeDelta / 2);
    return earthRadius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function nearestClubs(coordinates, clubs, limit) {
    return clubs.map(function (club) {
      return { club: club, miles: distanceMiles(coordinates[0], coordinates[1], club.lat, club.lon) };
    }).sort(function (a, b) { return a.miles - b.miles; }).slice(0, limit);
  }

  function pushEvent(name, values) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, values || {}));
  }

  function setStatus(root, message, state) {
    var status = root.querySelector('.form-status');
    if (!status) return;
    status.textContent = message || '';
    if (state) status.setAttribute('data-state', state);
    else status.removeAttribute('data-state');
  }

  function mark(root, fieldId, valid) {
    var field = query(root, fieldId);
    if (!field) return;
    field.classList.toggle('bad', !valid);
    var input = field.querySelector('input');
    if (input) input.setAttribute('aria-invalid', valid ? 'false' : 'true');
  }

  function normalizePhone(value) {
    var digits = value.replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    return '';
  }

  function directionsUrl(club) {
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(club.address);
  }

  function clubFeatureCollection(clubs) {
    return {
      type: 'FeatureCollection',
      features: clubs.map(function (club) {
        return {
          type: 'Feature',
          geometry: { type: 'Point', coordinates: [club.lon, club.lat] },
          properties: {
            id: String(club.id),
            name: club.name,
            state: club.state,
            address: club.address
          }
        };
      })
    };
  }

  function popupContent(club, meta) {
    var content = document.createElement('div');
    var name = document.createElement('p');
    var address = document.createElement('p');
    var detail = document.createElement('p');
    var directions = document.createElement('a');
    name.className = 'ctm-popup-name';
    name.textContent = 'Costco ' + club.name + ', ' + club.state;
    address.className = 'ctm-popup-address';
    address.textContent = club.address;
    detail.className = 'ctm-popup-meta';
    detail.textContent = meta || 'TACO MAC LAUNCH CLUB';
    directions.className = 'ctm-popup-directions';
    directions.href = directionsUrl(club);
    directions.target = '_blank';
    directions.rel = 'noopener';
    directions.textContent = 'Get directions';
    directions.addEventListener('click', function () {
      pushEvent('costco_tacomac_directions', { club_id: club.id, club_name: club.name });
    });
    content.append(name, address, detail, directions);
    return content;
  }

  function showClubPopup(state, club, meta, locked) {
    if (!state.map || !state.mapLoaded) return;
    state.popupLocked = Boolean(locked);
    state.popup.setLngLat([club.lon, club.lat]).setDOMContent(popupContent(club, meta)).addTo(state.map);
    var live = query(state.root, 'mapLive');
    if (live) live.textContent = 'Costco ' + club.name + ', ' + club.state + '. ' + club.address;
  }

  function closeHoverPopup(state) {
    window.clearTimeout(state.popupTimer);
    state.popupTimer = window.setTimeout(function () {
      if (!state.popupLocked && state.popup) state.popup.remove();
    }, 180);
  }

  function findClub(state, id) {
    return state.clubs.find(function (club) { return String(club.id) === String(id); });
  }

  function focusClub(state, match, animate) {
    state.matchedClub = match.club;
    state.matchedMiles = match.miles;
    if (!state.map || !state.mapLoaded) return;
    var meta = Number.isFinite(match.miles) ? Math.round(match.miles) + ' MILES AWAY' : 'TACO MAC LAUNCH CLUB';
    if (animate) {
      state.map.flyTo({ center: [match.club.lon, match.club.lat], zoom: 11.5, duration: 850, essential: true });
    }
    showClubPopup(state, match.club, meta, true);
  }

  function syncManualClubSelection(state, match) {
    if (state.locatorControl) {
      state.locatorControl.sequence += 1;
      state.locatorControl.pending = false;
      setLocatorPending(state.siblings || [state], false);
    }
    (state.siblings || [state]).forEach(function (other) {
      window.clearTimeout(other.focusTimer);
      other.focusTimer = null;
      other.matches = null;
      other.matchedClub = match.club;
      other.matchedMiles = match.miles;
    });
  }

  function addDirectoryRow(state, list, match) {
    var club = match.club;
    var row = document.createElement('div');
    var button = document.createElement('button');
    var name = document.createElement('span');
    var address = document.createElement('span');
    var directions = document.createElement('a');
    row.className = 'club-row';
    button.className = 'club-row-select';
    button.type = 'button';
    button.dataset.clubId = String(club.id);
    button.setAttribute('aria-label', 'Show Costco ' + club.name + ', ' + club.state + ' on the map');
    name.className = 'club-row-name';
    name.textContent = 'Costco ' + club.name + ', ' + club.state;
    address.className = 'club-row-address';
    address.textContent = club.address;
    button.append(name, address);
    if (Number.isFinite(match.miles)) {
      var distance = document.createElement('span');
      distance.className = 'club-row-distance';
      distance.textContent = Math.round(match.miles) + ' MILES AWAY';
      button.appendChild(distance);
    }
    directions.className = 'club-row-directions';
    directions.href = directionsUrl(club);
    directions.target = '_blank';
    directions.rel = 'noopener';
    directions.textContent = 'GET DIRECTIONS';
    button.addEventListener('click', function () {
      if (state.map && state.mapLoaded) {
        syncManualClubSelection(state, match);
        focusClub(state, match, true);
      }
      pushEvent('costco_tacomac_club_select', { club_id: club.id, club_name: club.name, source: 'directory' });
    });
    button.addEventListener('focus', function () {
      if (state.map && state.mapLoaded) showClubPopup(state, club, 'TACO MAC LAUNCH CLUB', false);
    });
    directions.addEventListener('click', function () {
      pushEvent('costco_tacomac_directions', { club_id: club.id, club_name: club.name, source: 'directory' });
    });
    row.append(button, directions);
    list.appendChild(row);
  }

  function renderDirectory(state, matches) {
    var list = query(state.root, 'clubList');
    var summary = query(state.root, 'clubDirectorySummary');
    var directory = query(state.root, 'clubDirectory');
    if (!list || !summary || !directory) return;
    list.replaceChildren();
    if (matches) {
      summary.textContent = matches.length + ' CLOSEST LAUNCH CLUBS TO ' + state.postalCode;
      matches.forEach(function (match) { addDirectoryRow(state, list, match); });
      directory.open = true;
      updateDirectoryMapControls(state);
      return;
    }
    summary.textContent = 'VIEW ALL ' + state.clubs.length + ' LAUNCH CLUBS';
    var currentState = '';
    state.clubs.forEach(function (club) {
      if (club.state !== currentState) {
        currentState = club.state;
        var heading = document.createElement('p');
        heading.className = 'club-state-heading';
        heading.textContent = currentState;
        list.appendChild(heading);
      }
      addDirectoryRow(state, list, { club: club, miles: NaN });
    });
    updateDirectoryMapControls(state);
  }

  function updateDirectoryMapControls(state) {
    state.root.querySelectorAll('.club-row-select').forEach(function (button) {
      button.disabled = !state.mapLoaded;
      button.setAttribute('aria-disabled', state.mapLoaded ? 'false' : 'true');
      button.title = state.mapLoaded ? '' : 'Interactive map unavailable. Use Get directions.';
    });
  }

  function renderLocatorStatus(state, matches, postalCode) {
    var status = query(state.root, 'locatorStatus');
    if (!status) return;
    if (!postalCode) {
      status.hidden = true;
      status.textContent = '';
      return;
    }
    status.hidden = false;
    if (!matches || !matches.length) {
      status.textContent = 'NO LAUNCH CLUB WITHIN 200 MILES OF ' + postalCode + '. VIEW ALL CLUBS BELOW.';
      return;
    }
    status.textContent = 'CLOSEST: COSTCO ' + matches[0].club.name.toUpperCase() + ', ' +
      matches[0].club.state + '. ' + Math.round(matches[0].miles) + ' MILES FROM ' + postalCode + '.';
  }

  function fitAllClubs(state) {
    if (!state.map || !state.mapLoaded) return;
    state.popupLocked = false;
    state.popup.remove();
    var live = query(state.root, 'mapLive');
    if (live) live.textContent = '';
    state.map.fitBounds(US_BOUNDS, { padding: 24, duration: 700, essential: true });
  }

  function applyMapFocus(state, matches) {
    var banner = query(state.root, 'mapBanner');
    if (!state.map || !state.mapLoaded || !banner) return;
    window.clearTimeout(state.focusTimer);
    state.focusTimer = null;
    if (!matches || !matches.length) {
      fitAllClubs(state);
      banner.textContent = state.postalCode ? 'NO LAUNCH CLUB WITHIN 200 MILES OF ' + state.postalCode : '85 COSTCO CLUBS IN THE AUGUST LAUNCH';
      banner.hidden = false;
      return;
    }
    banner.hidden = true;
    var bounds = new window.mapboxgl.LngLatBounds();
    matches.forEach(function (match) { bounds.extend([match.club.lon, match.club.lat]); });
    state.map.fitBounds(bounds, { padding: 70, maxZoom: 10.5, duration: 800, essential: true });
    state.focusTimer = window.setTimeout(function () {
      state.focusTimer = null;
      if (state.matches === matches) focusClub(state, matches[0], false);
    }, 820);
  }

  function enhanceBasemapContrast(map) {
    var paintUpdates = [
      ['land', 'background-color', ['interpolate', ['linear'], ['zoom'], 9, 'hsl(220, 3%, 97%)', 11, 'hsl(220, 1%, 95%)']],
      ['national-park', 'fill-color', 'hsl(220, 5%, 89%)'],
      ['landuse', 'fill-color', 'hsl(220, 5%, 89%)'],
      ['waterway', 'line-color', 'hsl(220, 2%, 80%)'],
      ['water', 'fill-color', 'hsl(220, 2%, 83%)'],
      ['building', 'fill-color', 'hsl(220, 0%, 88%)'],
      ['building', 'fill-outline-color', 'hsl(220, 0%, 81%)'],
      ['admin-1-boundary', 'line-color', 'hsl(220, 1%, 63%)'],
      ['admin-0-boundary', 'line-color', 'hsl(220, 0%, 61%)'],
      ['admin-0-boundary-disputed', 'line-color', 'hsl(220, 0%, 61%)'],
      ['road-label-simple', 'text-color', 'hsl(220, 1%, 43%)'],
      ['settlement-subdivision-label', 'text-color', 'hsl(220, 1%, 61%)'],
      ['settlement-minor-label', 'text-color', ['step', ['get', 'symbolrank'], 'hsl(220, 1%, 43%)', 11, 'hsl(220, 1%, 55%)', 16, 'hsl(220, 1%, 64%)']],
      ['settlement-major-label', 'text-color', ['step', ['get', 'symbolrank'], 'hsl(220, 1%, 43%)', 11, 'hsl(220, 1%, 55%)', 16, 'hsl(220, 1%, 64%)']],
      ['state-label', 'text-color', 'hsl(220, 1%, 43%)'],
      ['country-label', 'text-color', 'hsl(220, 1%, 43%)']
    ];
    paintUpdates.forEach(function (update) {
      if (map.getLayer(update[0])) map.setPaintProperty(update[0], update[1], update[2]);
    });
  }

  function initializeMap(state, token) {
    var banner = query(state.root, 'mapBanner');
    var useCooperativeTouch = Boolean(window.matchMedia && window.matchMedia('(any-pointer: coarse)').matches);
    if (!window.mapboxgl || !token || !window.mapboxgl.supported()) {
      if (banner) {
        banner.textContent = 'INTERACTIVE MAP IS TEMPORARILY UNAVAILABLE. USE THE CLUB LIST BELOW.';
        banner.hidden = false;
      }
      return;
    }
    try {
      window.mapboxgl.accessToken = token;
      state.popup = new window.mapboxgl.Popup({ closeButton: false, closeOnClick: false, offset: 14, maxWidth: '270px' });
      state.map = new window.mapboxgl.Map({
        container: query(state.root, 'mapCanvas'),
        style: 'mapbox://styles/mapbox/light-v11',
        center: [-95.5, 36],
        zoom: 2.3,
        minZoom: 2,
        maxZoom: 16,
        cooperativeGestures: useCooperativeTouch,
        attributionControl: true
      });
    } catch (error) {
      if (state.map) state.map.remove();
      state.map = null;
      state.popup = null;
      if (banner) {
        banner.textContent = 'INTERACTIVE MAP IS TEMPORARILY UNAVAILABLE. USE THE CLUB LIST BELOW.';
        banner.hidden = false;
      }
      return;
    }
    state.map.scrollZoom.enable();
    state.map.addControl(new window.mapboxgl.NavigationControl({ showCompass: false }), 'top-right');
    state.map.on('load', function () {
      state.mapLoaded = true;
      enhanceBasemapContrast(state.map);
      state.map.addSource('costco-clubs', {
        type: 'geojson',
        data: clubFeatureCollection(state.clubs),
        cluster: true,
        clusterMaxZoom: 8,
        clusterRadius: 40
      });
      state.map.addLayer({
        id: 'club-clusters',
        type: 'circle',
        source: 'costco-clubs',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': '#FFE500',
          'circle-radius': ['step', ['get', 'point_count'], 17, 12, 21, 30, 25],
          'circle-stroke-width': 2.5,
          'circle-stroke-color': '#000000'
        }
      });
      state.map.addLayer({
        id: 'club-cluster-count',
        type: 'symbol',
        source: 'costco-clubs',
        filter: ['has', 'point_count'],
        layout: { 'text-field': ['get', 'point_count_abbreviated'], 'text-size': 12 },
        paint: { 'text-color': '#000000' }
      });
      state.map.addLayer({
        id: 'club-points',
        type: 'circle',
        source: 'costco-clubs',
        filter: ['!', ['has', 'point_count']],
        paint: {
          'circle-color': '#FD21B2',
          'circle-radius': ['interpolate', ['linear'], ['zoom'], 3, 6, 11, 10],
          'circle-stroke-width': 2.5,
          'circle-stroke-color': '#000000'
        }
      });
      state.map.on('click', 'club-clusters', function (event) {
        var feature = state.map.queryRenderedFeatures(event.point, { layers: ['club-clusters'] })[0];
        state.map.getSource('costco-clubs').getClusterExpansionZoom(feature.properties.cluster_id, function (error, zoom) {
          if (!error) state.map.easeTo({ center: feature.geometry.coordinates, zoom: zoom });
        });
      });
      state.map.on('mouseenter', 'club-clusters', function () { state.map.getCanvas().style.cursor = 'pointer'; });
      state.map.on('mouseleave', 'club-clusters', function () { state.map.getCanvas().style.cursor = ''; });
      state.map.on('mouseenter', 'club-points', function (event) {
        state.map.getCanvas().style.cursor = 'pointer';
        var club = findClub(state, event.features[0].properties.id);
        if (club && !state.popupLocked) showClubPopup(state, club, 'TACO MAC LAUNCH CLUB', false);
      });
      state.map.on('mouseleave', 'club-points', function () {
        state.map.getCanvas().style.cursor = '';
        closeHoverPopup(state);
      });
      state.map.on('click', 'club-points', function (event) {
        var club = findClub(state, event.features[0].properties.id);
        if (club) {
          syncManualClubSelection(state, { club: club, miles: NaN });
          focusClub(state, { club: club, miles: NaN }, false);
          pushEvent('costco_tacomac_club_select', { club_id: club.id, club_name: club.name, source: 'map' });
        }
      });
      updateDirectoryMapControls(state);
      if (banner) banner.hidden = true;
      if (state.matches) applyMapFocus(state, state.matches);
      else if (state.matchedClub) {
        state.map.jumpTo({ center: [state.matchedClub.lon, state.matchedClub.lat], zoom: 11.5 });
        focusClub(state, { club: state.matchedClub, miles: state.matchedMiles }, false);
      }
      else fitAllClubs(state);
    });
    state.map.on('error', function () {
      if (banner && !state.mapLoaded) {
        banner.textContent = 'INTERACTIVE MAP IS TEMPORARILY UNAVAILABLE. USE THE CLUB LIST BELOW.';
        banner.hidden = false;
      }
    });
  }

  function activateVisibleMap(states, token) {
    states.forEach(function (state) {
      if (!isVisible(state.root)) {
        if (state.map) {
          state.map.remove();
          state.map = null;
          state.mapLoaded = false;
          state.popup = null;
          updateDirectoryMapControls(state);
        }
        return;
      }
      if (!state.clubs.length) return;
      if (!state.map) initializeMap(state, token);
      else state.map.resize();
    });
  }

  function focusMap(state, matches, postalCode) {
    window.clearTimeout(state.focusTimer);
    state.focusTimer = null;
    state.matches = matches;
    state.matchedClub = matches && matches.length ? matches[0].club : null;
    state.matchedMiles = matches && matches.length ? matches[0].miles : null;
    state.postalCode = postalCode;
    renderDirectory(state, matches);
    renderLocatorStatus(state, matches, postalCode);
    applyMapFocus(state, matches);
  }

  function resetLocator(state) {
    if (state.locatorControl) {
      state.locatorControl.sequence += 1;
      state.locatorControl.pending = false;
      setLocatorPending(state.siblings || [state], false);
    }
    (state.siblings || [state]).forEach(function (other) {
      window.clearTimeout(other.focusTimer);
      other.focusTimer = null;
      other.matches = null;
      other.matchedClub = null;
      other.matchedMiles = null;
      other.postalCode = '';
      var input = query(other.root, 'zip');
      var directory = query(other.root, 'clubDirectory');
      var banner = query(other.root, 'mapBanner');
      if (input) input.value = '';
      if (directory) directory.open = false;
      if (banner && other.mapLoaded) banner.hidden = true;
      renderDirectory(other, null);
      renderLocatorStatus(other, null, '');
      fitAllClubs(other);
    });
  }

  function syncMatch(states, matches, postalCode) {
    states.forEach(function (state) {
      var input = query(state.root, 'zip');
      if (input) input.value = postalCode;
      focusMap(state, matches, postalCode);
    });
  }

  function mirrorField(state, fieldId, value) {
    (state.siblings || [state]).forEach(function (other) {
      var field = query(other.root, fieldId);
      if (field && field.value !== value) field.value = value;
    });
  }

  function setSignupPending(states, pending) {
    states.forEach(function (state) {
      var form = query(state.root, 'optForm');
      var button = form ? form.querySelector('[data-ctm-form-submit]') : null;
      if (!button) return;
      if (!button.dataset.readyLabel) button.dataset.readyLabel = button.textContent;
      button.disabled = pending;
      button.textContent = pending ? 'Saving...' : button.dataset.readyLabel;
    });
  }

  function setLocatorPending(states, pending) {
    states.forEach(function (state) {
      var form = query(state.root, 'zipForm');
      var button = form ? form.querySelector('[data-ctm-form-submit]') : null;
      if (!button) return;
      if (!button.dataset.readyLabel) button.dataset.readyLabel = button.textContent;
      button.disabled = pending;
      button.textContent = pending ? 'Checking...' : button.dataset.readyLabel;
    });
  }

  function setSignupStatus(states, message, status) {
    states.forEach(function (state) { setStatus(state.root, message, status); });
  }

  function campaignFields() {
    var params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign')
    };
  }

  async function fetchJsonWithTimeout(url, label) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 10000);
    try {
      var response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error(label + ' returned ' + response.status + '.');
      return await response.json();
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function setZipValidation(states, message, valid) {
    states.forEach(function (state) {
      var error = query(state.root, 'zip-error');
      if (error) error.textContent = message;
      mark(state.root, 'f-zip', valid);
    });
  }

  function focusVisibleField(states, fieldId) {
    var visible = states.find(function (state) { return isVisible(state.root); });
    var field = visible ? query(visible.root, fieldId) : null;
    if (field) field.focus();
  }

  function setLocatorBanner(states, message) {
    states.forEach(function (state) {
      var banner = query(state.root, 'mapBanner');
      if (banner) {
        banner.textContent = message;
        banner.hidden = false;
      }
    });
  }

  function swapToSuccess(state) {
    var result = query(state.root, 'result');
    var success = query(state.root, 'success');
    if (!result || !success) return;
    result.style.opacity = '0';
    window.setTimeout(function () {
      result.hidden = true;
      success.hidden = false;
      void success.offsetWidth;
      success.classList.add('show');
      success.setAttribute('tabindex', '-1');
      if (isVisible(state.root)) success.focus();
    }, 240);
  }

  function subscriptionPayload(email, phone, listId) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Costco Taco Mac Launch Page',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                phone_number: phone,
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } }
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };
  }

  function profilePayload(email, state) {
    var properties = {
      'Costco Taco Mac Source': 'Shopify hidden launch page',
      'Costco Taco Mac Signup Date': new Date().toISOString()
    };
    var campaign = campaignFields();
    if (campaign.utm_source) properties['Costco Taco Mac UTM Source'] = campaign.utm_source;
    if (campaign.utm_medium) properties['Costco Taco Mac UTM Medium'] = campaign.utm_medium;
    if (campaign.utm_campaign) properties['Costco Taco Mac UTM Campaign'] = campaign.utm_campaign;
    if (state.postalCode) properties['Costco Taco Mac ZIP'] = state.postalCode;
    if (state.matchedClub) {
      properties['Costco Club ID'] = state.matchedClub.id;
      properties['Costco Club Name'] = state.matchedClub.name;
      properties['Costco Club State'] = state.matchedClub.state;
      properties['Costco Club Address'] = state.matchedClub.address;
      if (Number.isFinite(state.matchedMiles)) {
        properties['Costco Club Distance Miles'] = Math.round(state.matchedMiles);
      }
    }
    return {
      data: {
        type: 'profile',
        attributes: { email: email, properties: properties }
      }
    };
  }

  async function submitToKlaviyo(main, state, email, phone, signal) {
    var companyId = main.dataset.klaviyoCompanyId;
    var listId = main.dataset.klaviyoListId;
    if (!companyId || !listId) throw new Error('Signup configuration is incomplete.');
    var queryString = '?company_id=' + encodeURIComponent(companyId);
    var headers = {
      accept: 'application/vnd.api+json',
      'content-type': 'application/vnd.api+json',
      revision: '2026-04-15'
    };
    var profileResponse = await fetch('https://a.klaviyo.com/client/profiles' + queryString, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(profilePayload(email, state)),
      signal: signal
    });
    if (!profileResponse.ok) {
      throw new Error('Klaviyo profile returned ' + profileResponse.status + '.');
    }

    var subscriptionResponse = await fetch('https://a.klaviyo.com/client/subscriptions' + queryString, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(subscriptionPayload(email, phone, listId)),
      signal: signal
    });
    if (!subscriptionResponse.ok) {
      throw new Error('Klaviyo subscription returned ' + subscriptionResponse.status + '.');
    }
  }

  function initializeRevealEffects() {
    var elements = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) { element.classList.add('in'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    elements.forEach(function (element) { observer.observe(element); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var main = document.querySelector('.costco-tacomac');
    if (!main) return;

    var states = Array.from(main.querySelectorAll('[data-ctm-variant]')).map(function (root) {
      return {
        root: root,
        clubs: [],
        map: null,
        mapLoaded: false,
        popup: null,
        popupLocked: false,
        popupTimer: null,
        focusTimer: null,
        matches: null,
        matchedClub: null,
        matchedMiles: null,
        postalCode: ''
      };
    });
    states.forEach(function (state) { state.siblings = states; });
    var clubsPromise;
    var zipCoordinatesPromise;
    var locatorControl = { pending: false, sequence: 0 };
    var submissionControl = { pending: false };
    states.forEach(function (state) { state.locatorControl = locatorControl; });
    function loadClubs() {
      if (!clubsPromise) {
        clubsPromise = fetchJsonWithTimeout(main.dataset.costcoClubsUrl, 'Club data').catch(function (error) {
          clubsPromise = null;
          throw error;
        });
      }
      return clubsPromise;
    }
    function loadZipCoordinates() {
      if (!zipCoordinatesPromise) {
        zipCoordinatesPromise = fetchJsonWithTimeout(main.dataset.zipCoordinatesUrl, 'ZIP data').catch(function (error) {
          zipCoordinatesPromise = null;
          throw error;
        });
      }
      return zipCoordinatesPromise;
    }

    function installClubs(clubs) {
      states.forEach(function (state) {
        state.clubs = clubs;
        renderDirectory(state, state.matches);
        if (state.mapLoaded) {
          var source = state.map.getSource('costco-clubs');
          if (source) source.setData(clubFeatureCollection(clubs));
        }
      });
      activateVisibleMap(states, main.dataset.mapboxAccessToken);
    }

    loadClubs().then(installClubs).catch(function () {
      setLocatorBanner(states, 'CLUB LOCATOR IS TEMPORARILY UNAVAILABLE');
    });

    states.forEach(function (state) {
      var zipInput = query(state.root, 'zip');
      var emailInput = query(state.root, 'email');
      var phoneInput = query(state.root, 'phone');
      var zipForm = query(state.root, 'zipForm');
      var signupForm = query(state.root, 'optForm');
      var mapReset = query(state.root, 'mapReset');

      zipForm.querySelector('[data-ctm-form-submit]').type = 'submit';
      zipForm.querySelector('[data-ctm-form-submit]').disabled = false;
      signupForm.querySelector('[data-ctm-form-submit]').type = 'submit';
      signupForm.querySelector('[data-ctm-form-submit]').disabled = false;

      mapReset.addEventListener('click', function () { resetLocator(state); });

      zipInput.addEventListener('input', function () {
        zipInput.value = zipInput.value.replace(/\D/g, '').slice(0, 5);
        mirrorField(state, 'zip', zipInput.value);
      });
      emailInput.addEventListener('input', function () { mirrorField(state, 'email', emailInput.value); });
      phoneInput.addEventListener('input', function () { mirrorField(state, 'phone', phoneInput.value); });
      zipInput.addEventListener('blur', function () {
        if (zipInput.value) mark(state.root, 'f-zip', /^\d{5}$/.test(zipInput.value));
      });
      emailInput.addEventListener('blur', function () {
        if (emailInput.value) mark(state.root, 'f-email', /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim()));
      });
      phoneInput.addEventListener('blur', function () {
        if (phoneInput.value) mark(state.root, 'f-phone', Boolean(normalizePhone(phoneInput.value)));
      });

      zipForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (locatorControl.pending) return;
        var postalCode = zipInput.value;
        var valid = /^\d{5}$/.test(postalCode);
        setZipValidation(states, 'ENTER A 5-DIGIT ZIP CODE', valid);
        if (!valid) {
          focusVisibleField(states, 'zip');
          return;
        }
        var requestId = locatorControl.sequence + 1;
        locatorControl.sequence = requestId;
        locatorControl.pending = true;
        setLocatorPending(states, true);
        try {
          var values = await Promise.all([loadClubs(), loadZipCoordinates()]);
          if (locatorControl.sequence !== requestId) return;
          installClubs(values[0]);
          var coordinates = values[1][postalCode];
          if (!coordinates) {
            setZipValidation(states, 'ENTER A RECOGNIZED US ZIP CODE', false);
            focusVisibleField(states, 'zip');
            pushEvent('costco_tacomac_locator_error', { postal_code: postalCode, reason: 'unknown_zip' });
            return;
          }
          var matches = nearestClubs(coordinates, values[0], values[0].length).filter(function (match) {
            return match.miles <= MAX_DISTANCE_MILES;
          }).slice(0, 3);
          if (!matches.length) matches = null;
          syncMatch(states, matches, postalCode);
          pushEvent('costco_tacomac_locator', {
            postal_code: postalCode,
            club_id: matches ? matches[0].club.id : null,
            club_name: matches ? matches[0].club.name : null,
            distance_miles: matches ? Math.round(matches[0].miles) : null
          });
        } catch (error) {
          if (locatorControl.sequence !== requestId) return;
          setLocatorBanner(states, 'CLUB LOCATOR IS TEMPORARILY UNAVAILABLE. TRY AGAIN.');
          pushEvent('costco_tacomac_locator_error', {
            postal_code: postalCode,
            reason: error && error.name === 'AbortError' ? 'timeout' : 'data_error'
          });
        } finally {
          if (locatorControl.sequence === requestId) {
            locatorControl.pending = false;
            setLocatorPending(states, false);
          }
        }
      });

      signupForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (submissionControl.pending) return;
        var email = emailInput.value.trim();
        var phone = normalizePhone(phoneInput.value);
        var emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        var phoneValid = Boolean(phone);
        mark(state.root, 'f-email', emailValid);
        mark(state.root, 'f-phone', phoneValid);
        if (!emailValid || !phoneValid) {
          (emailValid ? phoneInput : emailInput).focus();
          return;
        }

        submissionControl.pending = true;
        setSignupPending(states, true);
        setSignupStatus(states, 'Saving your spot...', 'working');
        var controller = new AbortController();
        var timeout = window.setTimeout(function () { controller.abort(); }, 15000);
        var succeeded = false;
        try {
          await submitToKlaviyo(main, state, email, phone, controller.signal);
          succeeded = true;
          states.forEach(function (viewState) {
            var clubLine = query(viewState.root, 's-club');
            if (state.matchedClub) {
              clubLine.hidden = false;
              clubLine.textContent = 'We’ll email you when Taco Mac lands at Costco ' + state.matchedClub.name + ', ' + state.matchedClub.state + '.';
            } else {
              clubLine.hidden = true;
            }
            setStatus(viewState.root, '', '');
            swapToSuccess(viewState);
          });
          var campaign = campaignFields();
          pushEvent('costco_tacomac_signup', Object.assign({
            postal_code: state.postalCode || null,
            club_id: state.matchedClub ? state.matchedClub.id : null,
            club_name: state.matchedClub ? state.matchedClub.name : null
          }, campaign));
          window._learnq = window._learnq || [];
          window._learnq.push(['track', 'Costco Taco Mac Signup', {
            ZIP: state.postalCode || '',
            'Costco Club': state.matchedClub ? state.matchedClub.name : '',
            'UTM Source': campaign.utm_source || '',
            'UTM Medium': campaign.utm_medium || '',
            'UTM Campaign': campaign.utm_campaign || ''
          }]);
        } catch (error) {
          setSignupStatus(states, 'We could not save your spot. Please try again.', 'error');
          pushEvent('costco_tacomac_signup_error', {
            postal_code: state.postalCode || null,
            reason: error && error.name === 'AbortError' ? 'timeout' : 'klaviyo_error'
          });
        } finally {
          window.clearTimeout(timeout);
          submissionControl.pending = false;
          if (!succeeded) setSignupPending(states, false);
        }
      });

      state.root.querySelectorAll('[data-scroll-zip]').forEach(function (button) {
        button.addEventListener('click', function () {
          pushEvent('costco_tacomac_cta', Object.assign({
            cta_text: button.textContent.trim(),
            variant: state.root.dataset.ctmVariant
          }, campaignFields()));
          query(state.root, 'zip-card').scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        activateVisibleMap(states, main.dataset.mapboxAccessToken);
      }, 150);
    });
    initializeRevealEffects();
  });
})();
